import React from "react";

// Mui Styles
import { CurrencyFormat } from "@/config/normalConfig";
import { StyledPaper } from "@/styles/mui/globalStyles";
import { ButtonSendTheme, TableListTheme } from "@/styles/mui/tableListTheme";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import { makeStyles } from "@mui/styles";

// Navigate
import ProductAutoComplete from "@/components/Filter/productAutocomplete";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import AddOutlinedIcon from "@mui/icons-material/AddOutlined";
import EditIcon from "@mui/icons-material/Edit";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import SearchIcon from "@mui/icons-material/Search";
import SearchOutlinedIcon from "@mui/icons-material/SearchOutlined";
import LoadingButton from "@mui/lab/LoadingButton";
import { Box } from "@mui/material";
import Accordion from "@mui/material/Accordion";
import AccordionDetails from "@mui/material/AccordionDetails";
import AccordionSummary from "@mui/material/AccordionSummary";
import Fade from "@mui/material/Fade";
import IconButton from "@mui/material/IconButton";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableFooter from "@mui/material/TableFooter";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TextField from "@mui/material/TextField";
import Tooltip from "@mui/material/Tooltip";
import Typography from "@mui/material/Typography";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { useLocation } from "react-router-dom";

// Components
import SubExpensesDialog from "@/components/Dialog/subExpensesDialog";
import Layout from "@/components/layout";
import Title from "@/components/title";
import constant from "@/config/constant";
// Fetch
import {
  downloadExpensesExcel,
  getDistinctProduct,
  getExpenses,
} from "@/fetch/fetchExpenses";
import { getProducts } from "@/fetch/fetchStatistics";

// Moment
import { setSelectedDate, setSelectedProduct } from "@/features/systemSlice";
import { useCurrentAction } from "@/hooks/user";
import getDateRange from "@/lib/getDateRange";
import Grid from "@mui/material/Grid2";
import _ from "lodash";
import moment from "moment";
import "moment/locale/zh-hk";
import { useDispatch, useSelector } from "react-redux";
const ExpensesPage = (props) => {
  const { open, setOpen } = props;
  const actions = useCurrentAction();
  const dispatch = useDispatch();
  const location = useLocation();
  const { pathname } = location;
  // States
  const [isLoading, setIsLoading] = React.useState(false);

  const [isDownloading, setIsDownloading] = React.useState(false);

  const [snackSeverity, setSnackSeverity] = React.useState("success");
  const [snackMessage, setSnackMessage] = React.useState("");
  const [snackOpen, setSnackOpen] = React.useState(false);
  const [productOptions, setProductOptions] = React.useState([]);
  const [distinctProductOptions, setDistinctProductOptions] = React.useState(
    []
  );
  const [selectedBrand, setSelectedBrand] = React.useState(null);

  const [slideTranOn, setSlideTranOn] = React.useState(false);
  const [expanded, setExpanded] = React.useState(true);
  const [rows, setRows] = React.useState({});
  const [totalRow, setTotalRow] = React.useState({});
  const [dialogOpen, setDialoOpen] = React.useState(false);
  const [dialogFormData, setDialogFormData] = React.useState({});

  const defaultStartDate = moment().startOf("year").format("YYYY-MM-DD");
  const defaultEndDate = moment().endOf("year").format("YYYY-MM-DD");
  const selectedProduct = useSelector(
    (state) => state.system.selectedProduct[pathname] ?? null
  );
  const startDate = useSelector(
    (state) =>
      state.system.selectedDate[pathname]?.startDate ?? defaultStartDate
  );
  const endDate = useSelector(
    (state) => state.system.selectedDate[pathname]?.endDate ?? defaultEndDate
  );

  const theme = createTheme({
    components: {
      MuiOutlinedInput: {
        styleOverrides: {
          root: {
            borderRadius: 16,
          },
        },
      },
    },
  });
  const [dataRanges, setDataRanges] = React.useState([]);

  const handleDialogClose = async (event, reason) => {
    // await fetchExpenses();
    if (reason === "backdropClick" || reason === "escapeKeyDown") return;
    setDialoOpen(false);
  };
  const handleDownloadOnClick = async () => {
    try {
      setIsDownloading(true);
      setSnackMessage("下載中...");
      setSnackSeverity("info");
      setSnackOpen(true);
      await downloadExpensesExcel(startDate, endDate).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `expenses.xlsx`);
        document.body.appendChild(link);
        link.click();
        setSnackMessage("下載成功");
        setSnackSeverity("success");
        setIsDownloading(false);
      });
    } catch {
      setSnackMessage("下載失敗");
      setSnackSeverity("error");
      setIsDownloading(false);
    }
  };
  const onClickCreate = (e) => {
    e.preventDefault();
    e.stopPropagation();
    handleDialogOpen({
      parent_name: "",
      isSubExpenses: false,
      parent_id: null,
      category: "",
      product_ids: selectedProduct ? [selectedProduct] : [],
      name: null,
      costs: [
        {
          cost: null,
          start_date: null,
          end_date: null,
          remark: "",
          is_locked: false,
          is_account_checked: false,
        },
      ],
    });
    //navigate("create");
  };
  const handleDialogOpen = (row) => {
    setDialogFormData(row);
    setDialoOpen(true);
  };
  const onClick = (row) => {
    handleDialogOpen(_.cloneDeep(row));
  };
  const fetctProduct = async () => {
    const { data: products } = await getProducts();
    const { data: distinctProducts } = await getDistinctProduct();
    setProductOptions(_.filter(products, (p) => p.product_unit_price > 0));
    setDistinctProductOptions(distinctProducts);
  };
  const handleOnFailure = async () => {
    setSnackMessage("新增／更新失敗");
    setSnackSeverity("error");
    setSnackOpen(true);
  };
  const handleOnSuccess = async () => {
    await fetchExpenses();
    setSnackMessage("新增／更新成功");
    setSnackSeverity("success");
    setSnackOpen(true);
    setDialoOpen(false);
  };
  const fetchExpenses = async () => {
    try {
      if (!selectedProduct) {
        return false;
      }
      setIsLoading(true);
      const { data: expenses } = await getExpenses(
        selectedProduct,
        startDate,
        endDate
      );
      const selectedDataRanges = getDateRange(startDate, endDate, "month");
      const rowData = {};
      const totalData = {};
      _.forEach(selectedDataRanges, (selectedDataRange) => {
        totalData[selectedDataRange] = 0;
      });
      _.forEach(expenses, (e) => {
        const row = {
          name: e.name,
          category: e.category,
          minDate: moment(e.start_date).format("YYYY-MM-DD"),
          id: e.id,
          _costs: {},
          costs: e.costs,
          parent_id: null,
          isSubExpenses: false,
          product_ids: e.product_ids,
        };
        _.forEach(e.costs, (cost) => {
          if (!rowData[e.category]) {
            rowData[e.category] = [];
          }

          const ranges = getDateRange(cost.start_date, cost.end_date, "month");

          const totalDay = getDateRange(cost.start_date, cost.end_date, "day");

          _.forEach(ranges, (range) => {
            const totalDayInRange = _.filter(
              totalDay,
              (d) => moment(d).format("YY年M月") === range
            );
            const proportion =
              (cost.cost / e.product_ids.length / totalDay.length) *
              totalDayInRange.length;

            const remark = cost.remark
              ? `${cost.remark} - ${CurrencyFormat(proportion, 0)}`
              : "";
            if (selectedDataRanges.includes(range)) {
              if (!row._costs[range]) {
                row._costs[range] = {
                  remark: remark,
                  proportion: proportion,
                };
              } else {
                row._costs[
                  range
                ].remark = `${row._costs[range].remark}\n${remark}`;
                row._costs[range].proportion += proportion;
              }
            }

            if (_.isNumber(totalData[range])) {
              totalData[range] += proportion;
            }
          });
        });
        row.total = _.reduce(
          row._costs,
          (result, value) => {
            return result + value.proportion;
          },
          0
        );
        rowData[e.category].push(row);

        _.forEach(e.sub_expenses, (sub_expenses) => {
          if (sub_expenses.id) {
            const subRow = {
              minDate: moment(e.start_date).format("YYYY-MM-DD"),
              parent_name: e.name,
              name: sub_expenses.name,
              id: sub_expenses.id,
              parent_id: e.id,
              _costs: {},
              costs: sub_expenses.costs,
              isSubExpenses: true,
              product_ids: sub_expenses.product_ids,
              category: sub_expenses.category,
            };
            _.forEach(sub_expenses.costs, (cost) => {
              if (!rowData[e.category]) {
                rowData[e.category] = [];
              }

              const ranges = getDateRange(
                cost.start_date,
                cost.end_date,
                "month"
              );
              const totalDay = getDateRange(
                cost.start_date,
                cost.end_date,
                "day"
              );

              _.forEach(ranges, (range) => {
                const totalDayInRange = _.filter(
                  totalDay,
                  (d) => moment(d).format("YY年M月") === range
                );
                const proportion =
                  (cost.cost / e.product_ids.length / totalDay.length) *
                  totalDayInRange.length;
                const remark = cost.remark
                  ? `${cost.remark} - ${CurrencyFormat(proportion, 0)}`
                  : "";
                if (selectedDataRanges.includes(range)) {
                  if (!subRow._costs[range]) {
                    subRow._costs[range] = {
                      remark: remark,
                      proportion: proportion,
                    };
                  } else {
                    subRow._costs[
                      range
                    ].remark = `${subRow._costs[range].remark}\n${remark}`;
                    subRow._costs[range].proportion += proportion;
                  }
                }

                if (_.isNumber(totalData[range])) {
                  totalData[range] += proportion;
                }
              });
            });
            subRow.total = _.reduce(
              subRow._costs,
              (result, value) => {
                return result + value.proportion;
              },
              0
            );
            rowData[e.category].push(subRow);
          }
        });
      });
      setDataRanges(selectedDataRanges);
      setTotalRow(totalData);
      setRows(rowData);
      setSlideTranOn(true);
      setExpanded(false);
    } catch (error) {
      console.log("error", error);
    } finally {
      setIsLoading(false);
    }
  };
  const useStyles = makeStyles({
    table: {
      minWidth: 650,
    },
    sticky: {
      position: "sticky",
      left: 0,
      background: "white",
      borderRight: "1px solid #ebebeb",
      whiteSpace: "nowrap",
    },
    stickyRight: {
      position: "sticky",
      right: 0,
      background: "white",
      borderLeft: "1px solid #ebebeb",
      whiteSpace: "nowrap",
    },
  });
  const renderCell = (row) => {
    if (!row) return;
    if (row.proportion && row.remark !== "")
      return (
        <Tooltip
          title={<div style={{ whiteSpace: "pre-line" }}>{row.remark}</div>}
        >
          {CurrencyFormat(row.proportion, 0)}
          <Typography variant="overline" sx={{ color: "red" }}>
            *
          </Typography>
        </Tooltip>
      );
    return <React.Fragment>{CurrencyFormat(row.proportion, 0)}</React.Fragment>;
  };
  React.useEffect(() => {
    if (selectedProduct) {
      fetchExpenses();
    }
  }, []);
  React.useEffect(() => {
    fetctProduct();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const classes = useStyles();

  return (
    <Layout
      header="ExpensesPage"
      open={open}
      setOpen={setOpen}
      snackOpen={snackOpen}
      snackClose={() => setSnackOpen(false)}
      snackMessage={snackMessage}
      snackSeverity={snackSeverity}
    >
      <Title
        title="開支"
        children={
          <div>
            <IconButton onClick={onClickCreate}>
              <AddOutlinedIcon />
            </IconButton>
            {actions.download && (
              <Tooltip title="下載所有產品">
                <IconButton
                  id="basic-button"
                  aria-haspopup="true"
                  onClick={handleDownloadOnClick}
                >
                  <FileDownloadIcon />
                </IconButton>
              </Tooltip>
            )}
          </div>
        }
      />
      <ThemeProvider theme={theme}>
        <Accordion
          expanded={expanded}
          style={{ flexGrow: 1, display: "block" }}
        >
          <AccordionSummary
            expandIcon={
              <ExpandMoreIcon
                onClick={() => setExpanded(!expanded)}
              ></ExpandMoreIcon>
            }
            aria-controls="panel1-content"
            id="panel1-header"
          >
            <SearchIcon></SearchIcon>
          </AccordionSummary>
          <AccordionDetails>
            <Grid container spacing={2}>
              <Grid
                container
                size={{
                  xs: 12,
                  md: 3,
                  lg: 3,
                }}
              >
                <DatePicker
                  label="開始日期"
                  maxDate={endDate}
                  value={startDate}
                  onChange={(newValue) => {
                    dispatch(
                      setSelectedDate({
                        page: pathname,
                        value: {
                          startDate: moment(newValue).format("YYYY-MM-DD"),
                          endDate,
                        },
                      })
                    );
                  }}
                  renderInput={(params) => (
                    <TextField {...params} sx={{ width: "100%" }} />
                  )}
                />
              </Grid>
              <Grid
                container
                size={{
                  xs: 12,
                  md: 3,
                  lg: 3,
                }}
              >
                <DatePicker
                  label="結束日期"
                  minDate={startDate}
                  value={endDate}
                  onChange={(newValue) => {
                    dispatch(
                      setSelectedDate({
                        page: pathname,
                        value: {
                          startDate,
                          endDate: moment(newValue).format("YYYY-MM-DD"),
                        },
                      })
                    );
                  }}
                  renderInput={(params) => (
                    <TextField {...params} sx={{ width: "100%" }} />
                  )}
                />
              </Grid>

              <Grid
                container
                size={{
                  xs: 12,
                  md: 5,
                  lg: 5,
                }}
              >
                <ProductAutoComplete
                  fullWidth={true}
                  productOptions={distinctProductOptions.filter((o) =>
                    selectedBrand
                      ? parseInt(o.brand_id) === parseInt(selectedBrand)
                      : true
                  )}
                  handleOnChange={(value) => {
                    dispatch(
                      setSelectedProduct({
                        page: pathname,
                        value,
                      })
                    );
                  }}
                  selectedValue={selectedProduct}
                  error={!selectedProduct}
                ></ProductAutoComplete>
              </Grid>
              <Grid
                container
                size={{
                  xs: 12,
                  md: 1,
                  lg: 1,
                }}
              >
                <ThemeProvider theme={ButtonSendTheme}>
                  <div
                    style={{
                      width: "100%",
                      height: "100%",
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <LoadingButton
                      size="small"
                      onClick={() => {
                        fetchExpenses();
                      }}
                      endIcon={<SearchOutlinedIcon fontSize="small" />}
                      loading={isLoading}
                      disabled={isLoading || !selectedProduct}
                      loadingPosition="end"
                      variant="contained"
                    >
                      確認
                    </LoadingButton>
                  </div>
                </ThemeProvider>
              </Grid>
            </Grid>
          </AccordionDetails>
        </Accordion>
      </ThemeProvider>
      <Fade in={slideTranOn} mountOnEnter unmountOnExit>
        <StyledPaper page={"yes"}>
          <ThemeProvider theme={TableListTheme}>
            <TableContainer sx={{ maxHeight: 650 }}>
              <Table stickyHeader>
                <TableHead>
                  <TableRow>
                    <TableCell
                      sx={{ zIndex: 999 }}
                      className={classes.sticky}
                    ></TableCell>
                    {dataRanges.map((dataRange) => (
                      <TableCell align="center">{dataRange}</TableCell>
                    ))}
                    <TableCell
                      sx={{ zIndex: 999 }}
                      className={classes.stickyRight}
                      align="center"
                    >
                      Total
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {constant.expensesCategory.sort().map((expensesCategory) => {
                    return (
                      <React.Fragment>
                        {rows[expensesCategory]?.length >= 1 && (
                          <TableRow>
                            <TableCell
                              sx={{
                                backgroundColor: "#bebebe!important",
                                fontWeight: "bold",
                                textDecoration: "underline",
                                position: "sticky",
                                left: 0,
                                borderRight: "none!important",
                                justifyContent: "flex-start",
                              }}
                              className={classes.sticky}
                              align="left"
                            >
                              {expensesCategory}
                            </TableCell>
                            {dataRanges.map((dataRange) => {
                              return (
                                <TableCell
                                  sx={{
                                    backgroundColor: "#bebebe",
                                  }}
                                ></TableCell>
                              );
                            })}
                            <TableCell
                              sx={{
                                backgroundColor: "#bebebe!important",
                                borderLeft: "none!important",
                              }}
                              className={classes.stickyRight}
                            ></TableCell>
                          </TableRow>
                        )}
                        {_.map(rows[expensesCategory], (row) => {
                          return (
                            <TableRow>
                              <TableCell
                                className={classes.sticky}
                                align="left"
                              >
                                <Box component="div" sx={{ display: "inline" }}>
                                  <IconButton
                                    variant="text"
                                    sx={{
                                      justifyContent: "flex-start",
                                      textAlign: "left",
                                      padding: 0,
                                      fontSize: 13,
                                      whiteSpace: "nowrap",
                                      fontWeight: row.isSubExpenses
                                        ? "normal"
                                        : "bold",
                                      fontStyle: row.isSubExpenses
                                        ? "italic"
                                        : "normal",
                                    }}
                                    size="small"
                                    color={"primary"}
                                    onClick={() => onClick(row)}
                                  >
                                    {row.isSubExpenses ? "-" : ""} {row.name}
                                    <EditIcon></EditIcon>
                                  </IconButton>
                                  {!row.isSubExpenses && (
                                    <IconButton
                                      color={"primary"}
                                      onClick={(e) => {
                                        e.preventDefault();
                                        e.stopPropagation();
                                        handleDialogOpen({
                                          minDate: row.minDate,
                                          parent_name: row.name,
                                          isSubExpenses: true,
                                          parent_id: row.id,
                                          category: row.category,
                                          product_ids: row.product_ids,
                                          name: null,
                                          costs: [
                                            {
                                              cost: null,
                                              start_date: null,
                                              end_date: null,
                                              remark: "",
                                            },
                                          ],
                                        });
                                      }}
                                    >
                                      <AddCircleIcon></AddCircleIcon>
                                    </IconButton>
                                  )}
                                </Box>
                              </TableCell>
                              {dataRanges.map((dataRange) => (
                                <TableCell
                                  sx={{
                                    minWidth: 100,
                                  }}
                                  align="center"
                                >
                                  {renderCell(row._costs[dataRange])}
                                </TableCell>
                              ))}
                              <TableCell
                                className={classes.stickyRight}
                                align="right"
                              >
                                {CurrencyFormat(row.total, 0)}
                              </TableCell>
                            </TableRow>
                          );
                        })}
                      </React.Fragment>
                    );
                  })}
                </TableBody>
                <TableFooter
                  sx={{
                    left: 0,
                    bottom: 0, // <-- KEY
                    zIndex: 2,
                    position: "sticky",
                    backgroundColor: "white",
                  }}
                >
                  <TableRow>
                    <TableCell className={classes.sticky}></TableCell>
                    {_.map(totalRow, (row) => {
                      return (
                        <TableCell sx={{ fontWeight: "bold" }} align="right">
                          {CurrencyFormat(row, 0)}
                        </TableCell>
                      );
                    })}
                    <TableCell
                      className={classes.stickyRight}
                      sx={{ fontWeight: "bold" }}
                      align="right"
                    >
                      {CurrencyFormat(
                        _.reduce(
                          totalRow,
                          (result, value) => {
                            return result + value;
                          },
                          0
                        ),
                        0
                      )}
                    </TableCell>
                  </TableRow>
                </TableFooter>
              </Table>
            </TableContainer>
          </ThemeProvider>
        </StyledPaper>
      </Fade>
      {dialogOpen && (
        <SubExpensesDialog
          formData={dialogFormData}
          selectedProduct={selectedProduct}
          onSuccess={handleOnSuccess}
          OnFailure={handleOnFailure}
          open={dialogOpen}
          onCancel={handleDialogClose}
          productOptions={productOptions}
        ></SubExpensesDialog>
      )}
    </Layout>
  );
};

export default ExpensesPage;
